import * as React from 'react';
import { Text } from 'office-ui-fabric-react';
import { jsx as _jsx } from "react/jsx-runtime";
const TrackLabelStyles = {
  Audio: {
    root: {
      borderRadius: '3px;',
      border: '1px solid rgba(0, 0, 0, 0.2);',
      padding: '0 1px 1px 1px;'
    }
  },
  Subtitle: {
    root: {
      borderRadius: '3px;',
      color: 'rgba(255, 255, 255, 1);',
      border: '1px solid rgba(0, 0, 0, 0.6);',
      backgroundColor: 'rgba(0, 0, 0, 0.6);',
      padding: '0 1px 1px 1px;'
    }
  }
};
export const TrackLabel = _ref => {
  let {
    trackType,
    languageCode,
    variant
  } = _ref;
  return /*#__PURE__*/_jsx(Text, {
    variant: variant,
    styles: TrackLabelStyles[trackType],
    children: languageCode
  });
};